import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogrishneshwarcab() {



    const cardData = {

keyword: "Pune to Grishneshwar Cab",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Grishneshwar Cab services for pilgrims, families, and tourists visiting one of the twelve sacred Jyotirlingas of Lord Shiva. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a smooth long-distance journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are planning a spiritual pilgrimage or a heritage tour, Rising Cab Service ensures a reliable and hassle-free travel experience to Grishneshwar.",

topPlaces: [
    {
        title: "Grishneshwar Jyotirlinga Temple",
        description:
            "Grishneshwar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and a highly revered pilgrimage destination. The temple is admired for its ancient architecture, intricate stone carvings, and deep spiritual significance."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves, a UNESCO World Heritage Site, are located close to Grishneshwar Temple and feature magnificent Hindu, Buddhist, and Jain rock-cut monuments, including the famous Kailasa Temple."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is an impressive hill fort known for its strategic design, ancient tunnels, strong fortifications, and panoramic views of the surrounding landscape."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Bibi Ka Maqbara is a beautiful Mughal monument often called the Mini Taj Mahal due to its elegant architecture and historical importance."
    },
    {
        title: "Panchakki",
        description:
            "Panchakki is a historic water mill built during the Mughal era and is famous for its unique engineering system and peaceful surroundings."
    },
    {
        title: "Aurangabad Caves",
        description:
            "Aurangabad Caves are ancient Buddhist rock-cut caves showcasing detailed sculptures, artistic carvings, and significant archaeological heritage."
    },
    {
        title: "Bhadra Maruti Temple",
        description:
            "Bhadra Maruti Temple at Khuldabad is a famous shrine dedicated to Lord Hanuman and is one of the few temples featuring a reclining idol of the deity."
    },
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves are a UNESCO World Heritage Site renowned for their ancient Buddhist paintings, sculptures, and rock-cut architecture dating back more than two thousand years."
    },
    {
        title: "Jayakwadi Dam",
        description:
            "Jayakwadi Dam is one of Maharashtra's largest dams and is known for its scenic reservoir, bird sanctuary, and picturesque natural surroundings."
    },
    {
        title: "Khuldabad",
        description:
            "Khuldabad is a historic town near Grishneshwar famous for its ancient tombs, Mughal monuments, and spiritual significance, including the tomb of Emperor Aurangzeb."
    }
],



services: [
    {
        name: "Pune to Ajanta Ellora Cab",
        description:
            "Rising Cab Service offers Pune to Ajanta Ellora Cab for comfortable and memorable heritage tours across Maharashtra. This service is perfect for families, tourists, pilgrims, and history enthusiasts visiting the UNESCO World Heritage Sites of Ajanta and Ellora Caves along with Grishneshwar Jyotirlinga and Chhatrapati Sambhajinagar. We provide well-maintained AC vehicles including sedans, SUVs, Innova Crysta, Tempo Travellers, and Urbania for one-way, round-trip, and multi-day tours. With experienced drivers, flexible itineraries, doorstep pickup and drop, transparent pricing, and 24x7 support, we ensure a safe and enjoyable sightseeing experience covering major historical, religious, and cultural attractions."
    },
    {
        name: "Ajanta Ellora Taxi from Pune",
        description:
            "Book Ajanta Ellora Taxi from Pune with Rising Cab Service for comfortable long-distance travel with professional drivers and customized sightseeing plans for families and groups."
    },
    {
        name: "Pune to Ajanta Caves Cab",
        description:
            "Our Pune to Ajanta Caves Cab service offers safe and affordable transportation to the world-famous Buddhist cave complex with flexible one-way and round-trip options."
    },
    {
        name: "Pune to Ellora Caves Taxi Service",
        description:
            "Rising Cab Service provides Pune to Ellora Caves Taxi Service for hassle-free travel to the historic cave temples with comfortable AC vehicles and experienced chauffeurs."
    },
    {
        name: "Ajanta Ellora Tour Package from Pune",
        description:
            "Book Ajanta Ellora Tour Package from Pune including sightseeing, flexible travel schedules, and comfortable transportation for a complete heritage experience."
    },
    {
        name: "Pune to Ajanta Ellora Cab Booking",
        description:
            "Our Pune to Ajanta Ellora Cab Booking service offers instant confirmation, multiple vehicle choices, and reliable travel assistance for individuals and groups."
    },
    {
        name: "Pune to Ajanta Ellora Family Tour Cab",
        description:
            "Rising Cab Service offers Pune to Ajanta Ellora Family Tour Cab with spacious vehicles and comfortable seating for enjoyable family vacations and pilgrimage tours."
    },
    {
        name: "Luxury Cab Pune to Ajanta Ellora",
        description:
            "Choose Luxury Cab Pune to Ajanta Ellora for premium travel with Innova Crysta and luxury vehicles offering superior comfort and convenience."
    },
    {
        name: "Pune to Ajanta Ellora Tempo Traveller",
        description:
            "Our Pune to Ajanta Ellora Tempo Traveller service is ideal for large families, corporate groups, and tourist groups seeking spacious and economical group transportation."
    },
    {
        name: "Pune to Ajanta Ellora Sightseeing Cab",
        description:
            "Book Pune to Ajanta Ellora Sightseeing Cab for a complete tour covering Ajanta Caves, Ellora Caves, Daulatabad Fort, Bibi Ka Maqbara, and nearby attractions."
    },
    {
        name: "Pune to Grishneshwar Cab Service",
        description:
            "Rising Cab Service provides Pune to Grishneshwar Cab Service for comfortable pilgrimage travel to the sacred Jyotirlinga temple with one-way and round-trip options."
    },
    {
        name: "Pune to Grishneshwar Taxi Service",
        description:
            "Our Pune to Grishneshwar Taxi Service ensures safe and convenient travel for devotees visiting one of the twelve Jyotirlingas in India."
    },
    {
        name: "Pune to Grishneshwar Jyotirlinga Cab",
        description:
            "Book Pune to Grishneshwar Jyotirlinga Cab for a spiritual journey with experienced drivers and comfortable vehicles suitable for pilgrimage tours."
    },
    {
        name: "Grishneshwar Temple Cab from Pune",
        description:
            "Rising Cab Service offers Grishneshwar Temple Cab from Pune with reliable transportation, flexible schedules, and comfortable travel arrangements."
    },
    {
        name: "Pune to Grishneshwar Cab Booking",
        description:
            "Our Pune to Grishneshwar Cab Booking service provides instant booking confirmation and multiple vehicle options for families and pilgrims."
    },
    {
        name: "One Way Pune to Grishneshwar Cab",
        description:
            "Book One Way Pune to Grishneshwar Cab for economical travel with transparent pricing and professional drivers."
    },
    {
        name: "Round Trip Grishneshwar Taxi Pune",
        description:
            "Rising Cab Service offers Round Trip Grishneshwar Taxi Pune with waiting facilities and flexible return schedules for temple visits and sightseeing."
    },
    {
        name: "Pune to Grishneshwar Darshan Cab",
        description:
            "Our Pune to Grishneshwar Darshan Cab is specially designed for pilgrimage travel with comfortable vehicles and customized darshan plans."
    },
    {
        name: "Pune to Grishneshwar Innova Crysta",
        description:
            "Book Pune to Grishneshwar Innova Crysta for premium family travel with spacious seating and luxury comfort."
    },
    {
        name: "Pune to Grishneshwar Tempo Traveller",
        description:
            "Rising Cab Service provides Pune to Grishneshwar Tempo Traveller for group pilgrimage tours with spacious seating and comfortable travel."
    },
    {
        name: "Pune to Sambhajinagar Taxi",
        description:
            "Our Pune to Sambhajinagar Taxi service offers reliable intercity transportation with experienced drivers and well-maintained AC vehicles."
    },
    {
        name: "Pune to Aurangabad Taxi",
        description:
            "Book Pune to Aurangabad Taxi for business, tourism, and family travel with safe, comfortable, and affordable transportation."
    },
    {
        name: "Pune to Ajanta Ellora Tour Cab",
        description:
            "Rising Cab Service offers Pune to Ajanta Ellora Tour Cab for complete sightseeing experiences with customized travel plans and flexible itineraries."
    },
    {
        name: "Pune to Grishneshwar Temple Taxi",
        description:
            "Our Pune to Grishneshwar Temple Taxi ensures smooth pilgrimage travel with reliable drivers and comfortable AC vehicles."
    },
    {
        name: "Aurangabad Outstation Cab Pune",
        description:
            "Book Aurangabad Outstation Cab Pune for safe and convenient intercity travel with flexible one-way and round-trip options."
    },
    {
        name: "Pune to Sambhajinagar Innova Crysta",
        description:
            "Rising Cab Service offers Pune to Sambhajinagar Innova Crysta with premium comfort and spacious seating for family and business travel."
    },
    {
        name: "Pune to Aurangabad Tempo Traveller",
        description:
            "Our Pune to Aurangabad Tempo Traveller service is perfect for group tours, corporate outings, and family vacations."
    },
    {
        name: "Pune to Ajanta Ellora Urbania",
        description:
            "Book Pune to Ajanta Ellora Urbania for luxury group travel with premium interiors, comfortable seating, and modern amenities for long-distance heritage tours."
    }
],

tableData: [
    ["Pune to Ajanta Ellora Cab", "Ajanta Ellora Taxi from Pune"],
    ["Pune to Ajanta Caves Cab", "Pune to Ellora Caves Taxi Service"],
    ["Ajanta Ellora Tour Package from Pune", "Pune to Ajanta Ellora Cab Booking"],
    ["Pune to Ajanta Ellora Family Tour Cab", "Luxury Cab Pune to Ajanta Ellora"],
    ["Pune to Ajanta Ellora Tempo Traveller", "Pune to Ajanta Ellora Sightseeing Cab"],
    ["Pune to Grishneshwar Cab Service", "Pune to Grishneshwar Taxi Service"],
    ["Pune to Grishneshwar Jyotirlinga Cab", "Grishneshwar Temple Cab from Pune"],
    ["Pune to Grishneshwar Cab Booking", "One Way Pune to Grishneshwar Cab"],
    ["Round Trip Grishneshwar Taxi Pune", "Pune to Grishneshwar Darshan Cab"],
    ["Pune to Grishneshwar Innova Crysta", "Pune to Grishneshwar Tempo Traveller"],
    ["Pune to Sambhajinagar Taxi", "Pune to Aurangabad Taxi"],
    ["Pune to Ajanta Ellora Tour Cab", "Pune to Grishneshwar Temple Taxi"],
    ["Aurangabad Outstation Cab Pune", "Pune to Sambhajinagar Innova Crysta"],
    ["Pune to Aurangabad Tempo Traveller", "Pune to Ajanta Ellora Urbania"]
],




whychoose: [
    {
        WhyChooseheading: "Comfortable Pune to Grishneshwar Cab Service",
        WhyChoosedescription: "Rising Cab Service provides reliable Pune to Grishneshwar cab transportation for devotees, families, pilgrimage groups, and tourists visiting one of the sacred Jyotirlinga temples."
    },
    {
        WhyChooseheading: "Ideal for Jyotirlinga Darshan Trips",
        WhyChoosedescription: "Travel conveniently to Grishneshwar Jyotirlinga with dedicated cab services designed for spiritual journeys, temple visits, and religious tours."
    },
    {
        WhyChooseheading: "Visit Multiple Attractions in One Journey",
        WhyChoosedescription: "Travelers can combine Grishneshwar Darshan with visits to Ellora Caves, Daulatabad Fort, Bibi Ka Maqbara, Panchakki, and other nearby attractions."
    },
    {
        WhyChooseheading: "Vehicle Options for Every Group Size",
        WhyChoosedescription: "Choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to your travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Packages Available",
        WhyChoosedescription: "Customers can select one-way cab services, same-day return trips, overnight travel, or customized pilgrimage packages."
    },
    {
        WhyChooseheading: "Pickup Service Across Pune and PCMC",
        WhyChoosedescription: "We offer doorstep pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby locations."
    },
    {
        WhyChooseheading: "Safe Travel with Experienced Drivers",
        WhyChoosedescription: "Our professional drivers are familiar with pilgrimage routes and ensure a smooth, safe, and comfortable travel experience."
    },
    {
        WhyChooseheading: "Perfect for Families and Senior Citizens",
        WhyChoosedescription: "Rising Cab Service offers convenient transportation for devotees of all age groups, including families traveling with elderly members."
    }
]
};

const faqData = [
    {
        question: "Why is Grishneshwar Temple famous?",
        answer: "Grishneshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and is an important pilgrimage destination for devotees from across India."
    },
    {
        question: "Can I book a one-way cab from Pune to Grishneshwar?",
        answer: "Yes, one-way cab services are available along with round-trip and customized pilgrimage packages."
    },
    {
        question: "Which places can be visited along with Grishneshwar Darshan?",
        answer: "Travelers often visit Ellora Caves, Daulatabad Fort, Bhadra Maruti Temple, Panchakki, and Bibi Ka Maqbara during the same trip."
    },
    {
        question: "Which vehicle is suitable for family pilgrimage travel?",
        answer: "Ertiga and Innova Crysta are popular choices because they offer spacious seating and comfortable travel."
    },
    {
        question: "Are Tempo Travellers available for religious groups?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, pilgrimage tours, and temple visits."
    },
    {
        question: "Can same-day return trips be arranged from Pune?",
        answer: "Yes, same-day return travel packages can be organized depending on the customer's schedule."
    },
    {
        question: "Do senior citizens frequently use this service?",
        answer: "Yes, many devotees prefer private cab travel because it offers comfort, flexibility, and doorstep transportation."
    },
    {
        question: "Can Grishneshwar be included in a Jyotirlinga tour package?",
        answer: "Yes, Grishneshwar can be combined with other Jyotirlinga destinations as part of a customized pilgrimage itinerary."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I reserve a Pune to Grishneshwar Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Mahesh Gawande",
        feedback:
            "Our Grishneshwar Jyotirlinga Darshan trip was arranged perfectly. The cab was comfortable, the driver was courteous, and we completed the pilgrimage without any travel concerns.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shubhangi Patil",
        feedback:
            "Traveling with elderly parents became very convenient through Rising Cab Service. We visited Grishneshwar and Ellora comfortably, and the entire journey was exceptionally smooth.",
        rating: 5
    }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Grishneshwar Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-grishneshwar-cab.jpg",
"description": "Book Pune to Grishneshwar Cab Service with Rising Cab Service for safe, comfortable, and affordable temple travel. Enjoy reliable outstation taxi service for Ajanta, Ellora, and Grishneshwar Jyotirlinga with AC sedans, SUVs, and Tempo Traveller options.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-grishneshwar-cab"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Grishneshwar Cab Service | Temple Tour Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Grishneshwar Cab Service for safe and comfortable Jyotirlinga and Ajanta Ellora temple tours. Get reliable AC cab service with sedan, SUV, and Tempo Traveller options."
/>

<meta
 name="keywords"
 content="Pune to Grishneshwar Cab, Pune to Ajanta Ellora Cab, Ajanta Ellora Taxi from Pune, Pune to Ajanta Caves Cab, Pune to Ellora Caves Taxi Service, Ajanta Ellora Tour Package from Pune, Pune to Ajanta Ellora Cab Booking, Pune to Ajanta Ellora Family Tour Cab, Luxury Cab Pune to Ajanta Ellora, Pune to Ajanta Ellora Tempo Traveller, Pune to Ajanta Ellora Sightseeing Cab, Pune to Grishneshwar Jyotirlinga Cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetogrishneshwarcab;